
(function () {
    'use strict';

    angular.module('thankview.signup')
        .controller('SignUpController', ['$scope', '$rootScope', 'ajax', '$window', function ($scope, $rootScope, ajax, $window) {
            $rootScope.bodyStyle = {
                height: '100%',
                display: 'table',
                background: 'linear-gradient(134deg, #0067A4 0%, #4B99BE 34%, #079494 65%, #03B36A 100%, #0A344E 100%)',
            };

            $scope.init = function () {
                $scope.formStep = 2;
                $scope.account_type = '';
                $scope.first_name = '';
                $scope.last_name = '';
                $scope.phone = '';
                $scope.email = '';
                $scope.organization = '';
                $scope.organization_size = '';
                $scope.login_url = '';
                $scope.sign_up_success = false;
            };

            $scope.selectAccountType = function ($event, type) {
                if ($event) $event.preventDefault();

                if (type === 'personal') {
                    $window.location.href = '/sign-up/personal';
                } else {
                    $scope.account_type = type;
                    $scope.formStep = 2;
                    $window.history.pushState(null, 'Get Started', '/sign-up/' + type);
                }
            };

            $scope.orgSize = function ($event) {
                if ($event) $event.preventDefault();

                $scope.organization_size = $event.target.textContent;
            };

            $scope.submitSignUp = function () {
                if (!$scope.signUp.$valid || $scope.loading) {
                    return;
                }

                $scope.loading = true;

                var params = {
                    account_type: $scope.account_type,
                    first_name: $scope.first_name,
                    last_name: $scope.last_name,
                    email: $scope.email,
                    phone: $scope.phone,
                    organization: $scope.organization,
                    organization_size: $scope.organization_size,
                };

                ajax.post('/sign-up/submit', params).then(function (data) {
                    $scope.loading = false;

                    if (data.login_url) {
                        $scope.login_url = data.login_url;
                    }

                    if (data.signed_up) {
                        $scope.sign_up_success = data.signed_up;
                    }

                    if (data.repeat_sign_up) {
                        $scope.sign_up_repeat = data.repeat_sign_up;
                    }

                    $scope.formStep += 1;
                }).catch(function (data) {
                    $scope.loading = false;

                    if (data.email === '') {
                        $scope.signUp.email.$setValidity('required', false);
                    }
                    if (data.firstName === '') {
                        $scope.signUp.first_name.$setValidity('required', false);
                    }
                });
            };

            $scope.init();
        }]);
}());
